export enum ErrorCodeEnum {
  TOKEN_EXPIRED = 'E001',
  DUPLICATE_KEY = 'E002',
  DUPLICATE_NUTRIENT = 'E003',
  QR_CODES_NOT_AVAILABLE = 'E010',
  RFID_NOT_AVAILABLE = 'E011',
}
